import type {
  BudgetItemConfigurationModel,
  BudgetItemModel,
} from 'src/tpbp-json-api-handler/models/models'
import { logger } from 'src/utils/logger.utils'
import type { BUDGET_FREQUENCY } from 'src/tpbp-core/models/budget/budgetItem.const'
import { BUDGET_MONTHLY_COEFFICIENT } from 'src/tpbp-core/models/budget/budgetItem.const'

export function entryCategoriesEnumLabel(
  budgetItem: BudgetItemModel,
  categories: Record<string, BudgetItemConfigurationModel> | null,
) {
  const { entryCategory: budgetItemCategory } = budgetItem
  const label = categories
    ? categories[budgetItemCategory]?.displayedCategory
    : undefined
  return label ?? budgetItemCategory
}

export function getMonthlyAmount(
  amount: number,
  frequency: BUDGET_FREQUENCY | string,
) {
  if (!Object.hasOwn(BUDGET_MONTHLY_COEFFICIENT, frequency)) {
    logger.warn(`Unknown frequency '${frequency}' in getMonthlyAmount()`)
  }
  return amount * (BUDGET_MONTHLY_COEFFICIENT[frequency] ?? 0)
}

export function getAnnualAmount(
  amount: number,
  frequency: BUDGET_FREQUENCY | string | undefined,
) {
  if (frequency === undefined) {
    return 0
  }
  if (!Object.hasOwn(BUDGET_MONTHLY_COEFFICIENT, frequency)) {
    logger.warn(`Unknown frequency '${frequency}' in getAnnualAmount()`)
  }
  return 12 * amount * (BUDGET_MONTHLY_COEFFICIENT[frequency] ?? 0)
}

export function getMonthlySumAmount(budgetItems: BudgetItemModel[]) {
  return budgetItems.reduce((monthly, budgetItem) => {
    const { amount, frequency } = budgetItem
    return monthly + getMonthlyAmount(amount, frequency)
  }, 0)
}
